import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDialog,
    {
      attrs: {
        title: _setup.dialogTitle,
        size: "fullscreen",
        transition: "dialog-bottom-transition",
        attach: "",
        divider: "",
      },
      scopedSlots: _vm._u([
        {
          key: "prependBtn",
          fn: function ({ btnProps }) {
            return [
              _c(
                VBtn,
                _vm._b(
                  {
                    on: {
                      click: function ($event) {
                        _setup.isOpened = false
                      },
                    },
                  },
                  "v-btn",
                  btnProps,
                  false
                ),
                [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _setup.isOpened,
        callback: function ($$v) {
          _setup.isOpened = $$v
        },
        expression: "isOpened",
      },
    },
    [
      _vm._v(" "),
      _vm._l(_setup.projectItems, function (project, index) {
        return _c(
          "div",
          {
            key: project.name,
            class: { "mt-8": index !== 0 },
            on: {
              click: function ($event) {
                return _setup.goToProject(project.url)
              },
            },
          },
          [
            _c(VImg, {
              attrs: {
                src: project.logo,
                height: "32",
                position: "left",
                contain: "",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "text-caption text-info--text" }, [
              _vm._v("\n      " + _vm._s(project.description) + "\n    "),
            ]),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }